import * as constants from './constants'
import api from '../../api'

const URL_BASE = 'absences'
const URL_BASE_ATTRS = 'absence-attrs'

export const getAttrs = () => {
  let request = '/'+URL_BASE_ATTRS
  return api.makeBasicRequest( request );
}

export const getRecords = ( query, action ) => {
  let request = '/'+URL_BASE
  if ( query )
    request += '?'+query.join('&');
  return api.makeRequest( request, constants.RECORDS_LOAD );
}

export const getRecord = ( recordId, action=null ) => {
  let request = '/'+URL_BASE+'/'+recordId;
  if ( action )
    return api.makeRequest( request, action );
  return api.makeBasicRequest( request );
}

export const updateRecord = record => {
  console.log( "Updating absence", record );
  if ( record.absence_id )
    return api.makeRequest({
      method: 'put',
      url: '/'+URL_BASE+'/'+record.absence_id,
      data: {
        record
      }},
      constants.RECORD_UPDATE
    )
  return api.makeRequest({
    method: 'post',
    url: '/'+URL_BASE,
    data: {
      record
    }},
    constants.RECORD_UPDATE
  )
}

export const deleteRecord = record => {
  console.log( "Deleting absence", record );
  return api.makeRequest({
      method: 'delete',
      url: '/'+URL_BASE+'/'+record.absence_id
    },
    constants.RECORD_DELETE,
  );
}
